module.exports = __webpack_public_path__ + "img/commerce7-view-conversations.93603bec.png";